const resources = {
    signInFree: 'Ouvrir une session pour profiter de l’expédition GRATUITE',
    signInAccount: 'Pas de compte?',
    signInAccountLink: 'Créer un compte',
    signInCTA: 'Ouvrir une session',
    status: 'Vous êtes',
    points: 'avec',
    join: 'S’inscrire à Beauty Insider',
    earn: 'pour accumuler des points à chaque achat.',
    ccRewards: 'Récompenses Carte de crédit',
    signInForPrefix: 'Sign in for',
    fastFreeShipping: 'FAST FREE Shipping',
    allOrders: 'on all orders',
    noMinSpend: 'with no min spend',
    newHere: 'New here?',
    joinNow: 'Join Now'
};

export default function getResource(label) {
    return resources[label];
}
